import React from "react";

/**
 * Dynamic report content for Demand - renders same data as shown in edit form.
 * Uses React components instead of HTML string/HTMLChunk for dynamic data.
 */
const DemandReportContent = ({ data }) => {
  if (!data || !data.master) {
    return null;
  }

  const { master, details = [], record = {} } = data;
  const branchName = master.BranchName || record.BranchName || "";
  const departmentName = master.DepartmentName || record.DepartmentName || "";
  const transactionDate = master.TransactionDate
    ? (typeof master.TransactionDate === "string"
      ? master.TransactionDate.split("T")[0]
      : master.TransactionDate)
    : "";

  const reportStyles = {
    container: {
      background: "white",
      padding: "10px 30px 10px 10px",
    },
    title: {
      display: "flex",
      flex: 1,
      justifyContent: "center",
    },
    titleText: {
      color: "black",
      fontWeight: "bold",
    },
    headingSeparator: {
      borderBottom: "1px solid #000",
      margin: "10px 0 16px 0",
    },
    period: {
      display: "flex",
      flex: 1,
      justifyContent: "center",
      fontSize: "11px",
      color: "black",
    },
    infoSection: {
      display: "flex",
      flex: 1,
      flexDirection: "column",
      justifyContent: "flex-start",
    },
    infoText: {
      fontSize: "14px",
      color: "black",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: 10,
    },
    th: {
      border: "1px solid #000",
      padding: "8px",
      textAlign: "left",
      color: "black",
      fontWeight: "bold",
    },
    td: {
      border: "1px solid #000",
      padding: "8px",
      color: "black",
    },
    totalRow: {
      textAlign: "right",
      marginTop: 10,
      color: "black",
    },
    summaryRow: {
      border: "1px solid #000",
      padding: "8px",
      color: "black",
      fontWeight: "bold",
    },
  };

  const totalQty = details.reduce(
    (sum, row) => sum + (parseFloat(row.QtyIU) || 0),
    0
  );
  const totalStock = details.reduce(
    (sum, row) => sum + (parseFloat(row.StockIU) || 0),
    0
  );

  return (
    <div style={reportStyles.container}>
      <div style={reportStyles.title}>
        <h1 style={reportStyles.titleText}>Demand Detail Report</h1>
      </div>
      <div style={reportStyles.headingSeparator} />

      <div style={reportStyles.infoSection}>
        <p style={reportStyles.infoText}>
          Transaction Number: <b>{master.TransactionNo || ""}</b>
        </p>
        <p style={reportStyles.infoText}>
          Branch: <b>{branchName}</b>
        </p>
        <p style={reportStyles.infoText}>
          Department: <b>{departmentName}</b>
        </p>
        <p style={reportStyles.infoText}>
          Date: <b>{transactionDate}</b>
        </p>
        <p style={reportStyles.infoText}>
          Status: <b>{master.IsSubmit || record.IsSubmit ? "Post" : "Un-Post"}</b>
        </p>
        {master.Description && (
          <p style={reportStyles.infoText}>
            Description: <b>{master.Description}</b>
          </p>
        )}
      </div>
      <br />
      <div>
        <table style={reportStyles.table}>
          <thead>
            <tr>
              <th style={reportStyles.th}>Item </th>
              <th style={reportStyles.th}>Unit</th>
              <th style={reportStyles.th}>Available Stock</th>
              <th style={reportStyles.th}>Quantity</th>
            </tr>
          </thead>
          <tbody>
            {details.map((row, index) => (
              <tr key={index}>
                <td style={reportStyles.td}>{row.ItemName || ""}</td>
                <td style={reportStyles.td}>{row.IssuanceUnit || ""}</td>
                <td style={reportStyles.td}>
                  {row.StockIU != null ? parseFloat(row.StockIU).toFixed(2) : "—"}
                </td>
                <td style={reportStyles.td}>
                  {row.QtyIU != null ? parseFloat(row.QtyIU).toFixed(2) : "0"}
                </td>
              </tr>
            ))}
            {details.length > 0 && (
              <tr>
                <td style={reportStyles.summaryRow} colSpan={2}>
                  Total
                </td>
                <td style={reportStyles.summaryRow}>
                  {totalStock.toFixed(2)}
                </td>
                <td style={reportStyles.summaryRow}>
                  {totalQty.toFixed(2)}
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <p style={reportStyles.totalRow}>
          Total Items : <b>{details.length.toFixed(2)}</b>
        </p>
      </div>
    </div>
  );
};

export default DemandReportContent;
